import { BusinessEntity, RegistrationType } from '@/@types/generated'

/**
 * A Broker Certificate holder — an entity registered as a broker rather than a
 * motor carrier (see CONTEXT.md "Broker Certificate"). Insurance and vehicle
 * credentials do not apply to these companies.
 *
 * Keys off `RegistrationType.Broker` only. A motor carrier with
 * `isAlsoBroker = true` is NOT a broker company — insurance and vehicles still
 * apply to them.
 *
 * Falls back to the pending application's registration type so the display is
 * consistent before a certificate has been issued.
 */
export function isBrokerCompany(company: BusinessEntity): boolean {
  return (
    company.motorCarrier?.certificate?.isBrokerCertificate === true ||
    company.motorCarrierApplication?.registrationType ===
      RegistrationType.BROKER
  )
}
